/**
 * Feedback Hooks
 *
 * React Query hooks for user feedback and NPS.
 */

import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../providers/SdkProvider';
import {
  FeedbackService,
  FeedbackInput,
  FeedbackResponse,
  NpsInput,
  NpsResponse,
} from '../services/feedback.service';

// ═══════════════════════════════════════════════════════════════════════
// QUERY KEYS
// ═══════════════════════════════════════════════════════════════════════

export const feedbackKeys = {
  all: ['feedback'] as const,
};

// ═══════════════════════════════════════════════════════════════════════
// HOOKS
// ═══════════════════════════════════════════════════════════════════════

/**
 * Submit feedback
 */
export function useSubmitFeedback() {
  const client = useApiClient();
  const service = new FeedbackService(client);

  return useMutation<FeedbackResponse, Error, FeedbackInput>({
    mutationFn: (input) => service.submitFeedback(input),
  });
}

/**
 * Submit NPS score
 */
export function useSubmitNps() {
  const client = useApiClient();
  const service = new FeedbackService(client);

  return useMutation<NpsResponse, Error, NpsInput>({
    mutationFn: (input) => service.submitNps(input),
  });
}

// Re-export types
export type { FeedbackInput, FeedbackResponse, NpsInput, NpsResponse };
